import React from 'react';
import './Values.css';

const Values = () => {
  const navigateToPage = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const values = [
    {
      id: 1,
      title: 'Comunidad',
      tag: 'CONEXIÓN REAL',
      description: 'Más que productos, conexión real. Para quienes vibran con la marca.',
      image: '/images/pillar-comunidad.png',
      cta: 'Conocer más',
      link: '/contacto'
    },
    {
      id: 2,
      title: 'Colombia',
      tag: 'NUESTRAS RAÍCES',
      description: 'Artesanías, joyería, viajes y bienestar desde Colombia para el mundo.',
      image: '/images/pillar-colombia.png',
      cta: 'Ver viajes',
      link: '/conoce-colombia'
    },
    {
      id: 3,
      title: 'Bienestar',
      tag: 'CALMA Y CONEXIÓN',
      description: 'Yoga, viajes de ecoturismo comunitario y espacios diseñados para generar calma.',
      image: '/images/pillar-bienestar.png',
      cta: 'Explorar',
      link: '/bienestar'
    }
  ];

  return (
    <section className="values values-banner" id="valores">
      <div className="values-banners">
        {values.map((value) => (
          <div
            key={value.id}
            className="value-banner"
            onClick={() => navigateToPage(value.link)}
          >
            <img src={value.image} alt={value.title} />
            <div className="value-banner-overlay">
              <span className="value-tag">{value.tag}</span>
              <h3 className="value-headline">{value.title}</h3>
              <p className="value-desc">{value.description}</p>
              <button
                className="value-cta"
                onClick={(e) => { e.stopPropagation(); navigateToPage(value.link); }}
              >
                {value.cta}
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Values;
